import { createClient, createCache } from 'react-fetching-library';
import { setAuthorizationExpiresTimeout, setIsLogin } from '../redux_store';

const requestInterceptor = host => () => async action => {
  const headers = {
    ...action.headers,
    'Authorization-SetAsCookie': 'true',
    Client: 'dashboard',
    'Cache-Control': 'no-store, no-cache, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
    Accept: 'application/json',
    'Accept-Charset': 'utf-8',
  };

  // Add Content-Type for requests with body (but not for FormData)
  if (
    (action.method === 'POST' || action.method === 'PUT' || action.method === 'PATCH') &&
    action.body
  ) {
    // Don't set Content-Type for FormData - let browser set it with boundary
    if (!(action.body instanceof FormData)) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json; charset=utf-8';
    }
  }

  return {
    ...action,
    headers,
    credentials: 'include',
    endpoint: `${host}${action.endpoint}`,
  };
};

const responseInterceptor = dispatch => () => async (action, response) => {
  if (response.headers.has('Authorization-Expires') && dispatch) {
    dispatch(setIsLogin(true));
    dispatch(
      setAuthorizationExpiresTimeout(response.headers.get('Authorization-Expires').toString())
    );
  }

  if (response.payload.data !== undefined) {
    return {
      ...response,
      payload: response.payload.data,
    };
  }

  if (response.status === 410) {
    window.location.href = '/login#logout';
    return;
  }

  return response;
};

const CACHE_TIME = 3000;

const cache = createCache(
  action => action.method === 'GET',
  response => new Date().getTime() - response.timestamp < CACHE_TIME
);

const client = dispatch =>
  createClient({
    requestInterceptors: [requestInterceptor(process.env.REACT_APP_API_URL)],
    responseInterceptors: [responseInterceptor(dispatch)],
    cacheProvider: cache,
  });

export default client;
